import { TableCellProps } from '../models';
import styles from './invitedByCell.module.scss';

function InvitedBy({ row }: TableCellProps) {
  return (
    <span className={styles.cell} data-exclude-lg>
      <span className={styles.textContent}>
        {row.original.invitedByPersonName
          ? row.original.invitedByPersonName
          : '...'}
      </span>
    </span>
  );
}

export default InvitedBy;
